import ErrorHandlingForm from "../../../components/formValidation/ErrorHandlingForm";
import {useState} from "react";
import {validateRequired} from "../../../components/formValidation/validators";
import CustomRadioGroup from "../../../components/formValidation/CustomRadioGroup";
import {Box, FormControlLabel, Grid, Radio} from "@mui/material";
import Typography from "@mui/material/Typography";

const ProviderData = ({reference, data, setData}) => {

    const [errors, setErrors] = useState({
        payment_service: false,
    })

    const validators = {
        payment_service: [validateRequired, ],
    }

    return <ErrorHandlingForm
        reference={reference}
        data={data}
        setData={setData}
        errors={errors}
        setErrors={setErrors}
        validators={validators}
    >
        <CustomRadioGroup
            data={data}
            setData={setData}
            errors={errors}
            setErrors={setErrors}
            validators={validators}
            variant='standard'
            name='payment_service'
        >
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Box sx={{padding: '32px'}} className={data?.payment_service === 'simple' && 'active-radio'}>
                        <FormControlLabel value="simple" control={<Radio/>}
                                          label="Simple"/>
                        <Typography sx={{color: '#536B74'}} variant='body2'>Abban az esetben válaszd ezt az opciót,
                            ha rendelkezel api hozzáféréssel egy SimplePay fiókodhoz.</Typography>
                    </Box>
                </Grid>
            </Grid>

        </CustomRadioGroup>
    </ErrorHandlingForm>
}

export default ProviderData;